// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;For there the Lord has promised his blessing:&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;even life for evermore.<br> </p> </div></div>";
// Exports
module.exports = code;